import { render, staticRenderFns } from "./Legends.vue?vue&type=template&id=70a220f9&scoped=true&"
import script from "./Legends.vue?vue&type=script&lang=js&"
export * from "./Legends.vue?vue&type=script&lang=js&"
import style0 from "./Legends.vue?vue&type=style&index=0&id=70a220f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a220f9",
  null
  
)

export default component.exports